var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesBubbleWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.75.75a10.485 10.485 0 0 0-8.917 16.025L.75 23.25l6.474-3.084A10.5 10.5 0 1 0 12.75.75ZM12.75 14.25h0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.75 14.25a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375M12.75 11.25v-4.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesBubbleWarning);
export default __webpack_public_path__ + "static/media/messages-bubble-warning.bd14eb90c5c0c18216ecbb3138a3c3b6.svg";
export { ForwardRef as ReactComponent };